"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDatedEvidence = exports.FieldUpdated = exports.FieldCreated = exports.DatedFields = exports.useDatedColumns = void 0;
const react_1 = require("react");
const uuid_1 = require("uuid");
const detail_actionbar_empty_1 = require("../../detail/detail-actionbar-empty");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const dated_columns_1 = require("./dated-columns");
Object.defineProperty(exports, "useDatedColumns", { enumerable: true, get: function () { return dated_columns_1.useDatedColumns; } });
const dated_fields_1 = require("./dated-fields");
Object.defineProperty(exports, "DatedFields", { enumerable: true, get: function () { return dated_fields_1.DatedFields; } });
Object.defineProperty(exports, "FieldCreated", { enumerable: true, get: function () { return dated_fields_1.FieldCreated; } });
Object.defineProperty(exports, "FieldUpdated", { enumerable: true, get: function () { return dated_fields_1.FieldUpdated; } });
function useDatedEvidence(options) {
    var _a, _b, _c, _d, _e, _f;
    const { datedColumns } = (0, dated_columns_1.useDatedColumns)();
    const columns = (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.columns) !== null && _b !== void 0 ? _b : datedColumns;
    const defaultSorts = (0, react_1.useMemo)(() => {
        var _a, _b;
        return (_b = (_a = options.tableProps) === null || _a === void 0 ? void 0 : _a.defaultSorts) !== null && _b !== void 0 ? _b : [
            { field: 'created', datakey: 'created', order: 'DESC', type: 'FIELD' },
        ];
    }, [(_c = options.tableProps) === null || _c === void 0 ? void 0 : _c.defaultSorts]);
    const toolbarProps = (0, react_1.useMemo)(() => {
        var _a;
        return ({
            ActionBar: detail_actionbar_empty_1.DetailEmptyActionbar,
            ...(_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.toolbarProps,
        });
    }, [(_d = options.detailProps) === null || _d === void 0 ? void 0 : _d.toolbarProps]);
    const GeneralFieldsComponent = (_f = (_e = options.detailProps) === null || _e === void 0 ? void 0 : _e.GeneralFieldsComponent) !== null && _f !== void 0 ? _f : dated_fields_1.DatedFields;
    const initNewItem = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a, _b;
        const obj = {
            id: (0, uuid_1.v4)(),
        };
        if (((_a = options.detailProps) === null || _a === void 0 ? void 0 : _a.initNewItem) !== undefined) {
            return {
                ...obj,
                ...(_b = options.detailProps) === null || _b === void 0 ? void 0 : _b.initNewItem(),
            };
        }
        else {
            return obj;
        }
    });
    return {
        ...options,
        tableProps: { ...options.tableProps, columns, defaultSorts },
        detailProps: {
            ...options.detailProps,
            initNewItem,
            GeneralFieldsComponent,
            toolbarProps,
        },
    };
}
exports.useDatedEvidence = useDatedEvidence;
//# sourceMappingURL=dated-evidence.js.map